import { z } from "zod"

export const SegmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  condition: z.object({
    type: z.enum(["event", "custom_field"]),
    event: z.string().optional(),
    exit_after_days: z.number().optional(),
    field: z.string().optional(),
    value: z.any().optional(),
    negate: z.boolean().optional(),
  }),
})

export type Segment = z.infer<typeof SegmentSchema>
